function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#3A4164;stroke:#3A4164;stroke-linejoin:round;stroke-miterlimit:1.4142;}\n\t.st1{fill:#3A4164;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#3A4164;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#F88E9F;}\n\t.st4{fill:#F88E9F;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "ps",
  transform: "matrix(0.640466,0,0,0.640466,169.639,601.772)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.01682,0,0,1.01682,128.941,-134.911)"
}, /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M-204.02-791.3c26.38,0.08,50.54,22.66,50.79,50.47c0.14,44.34,0.14,88.68,0,133.01 c-0.25,26.34-23.09,50.23-50.47,50.47c-44.34,0.14-88.68,0.14-133.01,0c-26.34-0.25-50.21-23.09-50.47-50.47 c-0.14-44.34-0.14-88.68,0-133.01c0.25-26.28,22.76-50.21,50.47-50.47C-292.48-791.44-248.25-791.3-204.02-791.3z M-336.37-775.43 c-18.1,0.06-34.77,15.78-34.95,34.71c-0.13,44.34-0.4,88.69,0,133.03c0.28,17.87,15.7,34.19,34.49,34.49 c44.42,0.41,88.83,0.41,133.25,0c17.92-0.28,34.2-15.69,34.49-34.49c0.41-44.42,0.41-88.83,0-133.25 c-0.27-17.84-15.6-34.19-34.49-34.49C-247.85-775.83-292.11-775.43-336.37-775.43z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1,0,0,1,-0.819246,2.22573)"
}, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M-189.08-767.41h-19.38v-109.93c0,0,28.53-2.43,42.22,0.97c14.27,3.54,27.53,15.34,25.58,38.57 c-0.96,11.39-10.96,25.16-25.58,29.17c-12.16,3.33-22.84,2.16-22.84,2.16V-767.41z M-85.9-849.05v16.81c0,0-25.26-9.63-27.73,0 c-2.22,8.66,9.93,12.05,14.51,14.93c4.58,2.87,15.93,8.64,17.51,21.07c0.74,5.87-2.56,19.02-10.56,23.62 c-22.07,12.68-40.72-1.78-40.72-1.78v-16.29c0,0,10.21,4.09,19.26,5.27c11.16,1.45,16.48-7.81,9.57-12.14 c-7.76-4.84-14.49-5.58-24.12-15.43c-5.05-5.16-11.31-23.59,5.54-36.05c5.33-3.94,12.45-4.31,18.58-4.31 C-97.95-853.36-85.9-849.05-85.9-849.05z M-189.08-860.73v36.8c0,0,23.42,3.5,27.28-10.26c4.04-14.42-1.58-21.42-5.4-23.89 C-171.96-861.16-189.08-860.73-189.08-860.73z"
})));

function SvgPs(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 152.5 152.47",
    style: {
      enableBackground: "new 0 0 152.5 152.47"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPs);
export default __webpack_public_path__ + "static/media/ps.59315774.svg";
export { ForwardRef as ReactComponent };